import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Center } from '@fiverr-private/layout_components';
import { ComplianceAttentionIcon, ComplianceSuccessIcon, ComplianceInProgressIcon } from '@fiverr-private/visuals';
import Badge from '../Badge';
import { BaseBadgeProps } from '../../types';

type Type = 'info' | 'success' | 'warning';
interface Data {
  color: BaseBadgeProps['color'];
  bgColor: BaseBadgeProps['backgroundColor'];
  icon: (props: { color: BaseBadgeProps['color'] }) => JSX.Element;
}

const Data: Record<Type, Data> = {
  info: { color: 'blue_1100', bgColor: 'blue_200', icon: (props) => <ComplianceInProgressIcon color={props.color} /> },
  success: {
    color: 'green_1100',
    bgColor: 'green_200',
    icon: (props) => <ComplianceSuccessIcon color={props.color} />,
  },
  warning: {
    color: 'yellow_1200',
    bgColor: 'yellow_200',
    icon: (props) => <ComplianceAttentionIcon color={props.color} />,
  },
};
const ComplianceBadge = ({ isCompact = false, type = 'info' }: { type: Type; isCompact?: boolean }) => {
  const data = Data[type];

  if (!data) return null;

  const Icon = data.icon;

  if (isCompact) {
    return (
      <Badge disablePadding backgroundColor={data.bgColor} color={data.color}>
        <Center height={20} width={20}>
          <Icon color={data.color} />
        </Center>
      </Badge>
    );
  }

  return (
    <Badge backgroundColor={data.bgColor} color={data.color}>
      <Icon color={data.color} />
      <I18n k="badges.compliance_badge.text" />
    </Badge>
  );
};

ComplianceBadge.displayName = 'ComplianceBadge';

export default ComplianceBadge;
